export function getPasswordResetRequests(query, cb) {
  return simpleIsoFetch => dispatch => {
    return simpleIsoFetch.get({
      route: '/api/admin/passwordresetrequests',
      query,
    })
      .then(({body: {data: {items: passwordresetrequests}}}) => passwordresetrequests)
      .then((resp) => {

        if(cb) {
          return cb(null, resp);
        }
        return resp;
      })
      .catch(err => {
        if(cb) {
          return cb(err);
        }
        return Promise.reject(err);
      });
  };
}

export function getPushQueueItems(query, cb) {
    return simpleIsoFetch => dispatch => {
    return simpleIsoFetch.get({
      route: '/api/admin/pushqueueitems',
      query,
    })
      .then(({body: {data: {items: pushqueueitems}}}) => pushqueueitems)
      .then((resp) => {

        if(cb) {
          return cb(null, resp);
        }
        return resp;
      })
      .catch(err => {
        if(cb) {
          return cb(err);
        }
        return Promise.reject(err);
      });
  };
}



// WEBPACK FOOTER //
// ./shared/redux/actionCreators/async/admin.js